import { Toaster } from "../components/ui/toaster";
import { useToast } from "../components/ui/use-toast";
import { useEffect } from "react";
import { Navbar } from "../components/Navbar";
import {
  useGetSupportedMintsQuery,
  useGetUserQuery,
} from "../generated/graphql";
import { HistoryCard } from "../components/HistoryCard";
import { BalanceCard } from "../components/BalanceCard";
import RightNavbar from "../components/RightNavbar";

export function Dashboard() {
  const { toast } = useToast();

  const [{ data: userData, error: userError }] = useGetUserQuery();
  const [{ data: mintsData, error: mintsError }] = useGetSupportedMintsQuery();
  const username = userData?.getUser.username;
  const mints = mintsData?.getSupportedMints;

  useEffect(() => {
    if (userError) {
      toast({
        title: "Error",
        description: userError.message,
        variant: "destructive",
      });
    }

    if (mintsError) {
      toast({
        title: "Error",
        description: mintsError.message,
        variant: "destructive",
      });
    }
  }, [userError, toast, mintsError]);

  return (
    <div className="flex min-h-screen w-full">
      <div
        className="flex-grow overflow-x-auto"
        style={{ width: "calc(100% - 60px)" }}
      >
        <div className="flex flex-col w-full mr-0 sm:pr-[40px] lg:pr-[60px]">
          <Navbar />
          <main className="flex-1 p-4 md:p-8">
            <div className="grid gap-2 mb-4 md:mb-8">
              <div className="text-3xl font-bold">Welcome {username}!</div>
            </div>

            <div className="grid grid-cols-12 gap-4 mb-20">
              <div className="col-span-12 lg:col-span-5">
                <BalanceCard mintOptions={mints || []} />
              </div>
              <div className="col-span-12 lg:col-span-7">
                <HistoryCard />
              </div>
            </div>
          </main>
        </div>
      </div>
      <RightNavbar />
      <Toaster />
    </div>
  );
}
